import { render, staticRenderFns } from "./ProjectLogo.vue?vue&type=template&id=49f665a7&"
import script from "./ProjectLogo.vue?vue&type=script&lang=js&"
export * from "./ProjectLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports